import React from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'
import { useLocation } from 'react-router'
import { ROUTE } from '@enums/route'

type Location = {
  state: {
    email?: string
  }
}

const PrivateEmailRoute: React.FC<RouteProps> = ({ path, component }) => {
  const location = useLocation() as Location
  const ProtectedComponent = component as React.FC

  return (
    <Route
      path={path}
      component={() => {
        if (!location.state || !location.state.email) {
          return <Redirect to={ROUTE.logIn} />
        }
        return <ProtectedComponent />
      }}
    />
  )
}

export default PrivateEmailRoute
